import {
	Box,
	Divider,
	Typography,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Tooltip,
} from "@mui/material";

import flag from "../../flag.png";
import { useContext, useState, useRef } from "react";
import TPLSlidePanel from "./TPLSlidePanel";
import { exploreTooltips } from "../tooltipText";
import useLayerList from "../../hooks/useLayerList";
import { PrioritizeSlidersContext } from "../../contexts/PrioritizeSlidersContext";
import { customPrioritizationLayerColors } from "../../constants";
import { trackEvent } from "../../hooks/useAnalytics";

export default function Explore() {
	const {
		prioritizeSlidersValue,
		setPrioritizeSlidersValue,
		checked,
		setChecked,
		hideOtherLayers,
		setHideOtherLayers,
	} = useContext(PrioritizeSlidersContext);
	const { layerList, overlays } = useLayerList();

	const [expand, setExpand] = useState<boolean>(false);

	let legendHolder = useRef(null);

	const changeLayerVisibility = (layer: __esri.Layer, event?: any) => {
		event?.stopPropagation();
		setHideOtherLayers(false);
		if (layer.visible) {
			layer.visible = false;
			setExpand(false);
		} else {
			setExpand(true);
			layer.visible = true;
		}
		const layer_vis = layer.visible ? "on" : "off";

		///name: explore_tab_layers
		//category: layer_toggle
		//action: on_or_off (current vis of layer)
		//label: layer_name_vis
		const combo = `${layer.title}_${layer_vis}`;
		//trackEvent('explore_tab_layers', 'layer_toggle', layer_vis, layer.title)
		//trackLayerOnOff(combo);
		trackEvent("layer_toggle", combo);
	};

	const CreateOverlayLegend = ({ name }: any) => {
		return (
			<Box>
				{name.toLowerCase().includes("urban heat") ? (
					<Box
						display="flex"
						flexDirection="column"
						sx={{
							gap: "5px",
						}}
						px={2}
						py={1}
						mx={2.4}
					>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#FAF75D",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Moderate</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#FBD15A",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Moderately Severe</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#FDAA59",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Severe</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#FE845A",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Very Severe</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#FE675A",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Extreme</Box>
						</Box>
					</Box>
				) : name.toLowerCase().includes("pollution") ? (
					<Box
						display="flex"
						flexDirection="column"
						sx={{
							gap: "5px",
						}}
						px={2}
						py={1}
						mx={2.4}
					>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#cc8f69",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Very High</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#e0bba5",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>High</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#edd7ca",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Medium</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#feea9b",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Low</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#b3d39f",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Very Low</Box>
						</Box>
					</Box>
				) : name.toLowerCase().includes("heat risk") ? (
					<Box
						display="flex"
						flexDirection="column"
						sx={{
							//height: "auto",
							gap: "5px",
						}}
						px={2}
						py={1}
						mx={2.4}
					>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",

									backgroundColor: "#f7931e",
									opacity: 0.5,
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Priority Zones</Box>
						</Box>
					</Box>
				) : name.toLowerCase().includes("physical") ? (
					<Box
						display="flex"
						flexDirection="column"
						sx={{
							//height: "auto",
							gap: "5px",
						}}
						px={2}
						py={1}
						mx={2.4}
					>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#58a3df",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Very High</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#82bae7",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>High</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#a3ccee",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Medium</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#bcdaf2",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Low</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#d5e8f7",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Very Low</Box>
						</Box>
					</Box>
				) : name.toLowerCase().includes("poor mental") ? (
					<Box
						display="flex"
						flexDirection="column"
						sx={{
							//height: "auto",
							gap: "5px",
						}}
						px={2}
						py={1}
						mx={2.4}
					>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#58a3df",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Very High</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#82bae7",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>High</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#a3ccee",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Medium</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#bcdaf2",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Low</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#d5e8f7",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Very Low</Box>
						</Box>
					</Box>
				) : name.toLowerCase().includes("linguistic") ||
				  name.toLowerCase().includes("population density") ||
				  name.toLowerCase().includes("children under") ||
				  name.toLowerCase().includes("over age") ||
				  name.toLowerCase().includes("people of color") ||
				  name.toLowerCase().includes("high school") ||
				  name.toLowerCase().includes("limited") ||
				  name.toLowerCase().includes("low-income") ? (
					<Box
						display="flex"
						flexDirection="column"
						sx={{
							//height: "auto",
							gap: "5px",
						}}
						px={2}
						py={1}
						mx={2.4}
					>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#e058a4",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Very High</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#e882bb",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>High</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#eea3cd",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Medium</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#f3bcda",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Low</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#f9ddec",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Very Low</Box>
						</Box>
					</Box>
				) : name.toLowerCase().includes("park acres") ? (
					<Box
						display="flex"
						flexDirection="column"
						sx={{
							//height: "auto",
							gap: "5px",
						}}
						px={2}
						py={1}
						mx={2.4}
					>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#e9ae6a",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Very High</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#f9b86c",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>High</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#fbca90",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Medium</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#fcdbb5",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Low</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: "#fdedda",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Very Low</Box>
						</Box>
					</Box>
				) : name.toLowerCase().includes("income - neighborhoods") ? (
					<Box
						display="flex"
						flexDirection="column"
						sx={{
							//height: "auto",
							gap: "5px",
						}}
						px={2}
						py={1}
						mx={2.4}
					>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "14px",
									width: "14px",
									border: "2px solid #39b54a",
									backgroundColor: "none",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Low Income</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "14px",
									width: "14px",
									border: "2px solid #a44dc4",
									backgroundColor: "none",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>High Income</Box>
						</Box>
					</Box>
				) : name.toLowerCase().includes("race - neighborhoods") ? (
					<Box
						display="flex"
						flexDirection="column"
						sx={{
							//height: "auto",
							gap: "5px",
						}}
						px={2}
						py={1}
						mx={2.4}
					>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "14px",
									width: "14px",
									border: "2px solid #0073cf",
									backgroundColor: "none",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>People of Color</Box>
						</Box>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "14px",
									width: "14px",
									border: "2px solid #b87121",
									backgroundColor: "none",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>White</Box>
						</Box>
					</Box>
				) : name.toLowerCase().includes("trail") ? (
					<Box
						display="flex"
						flexDirection="column"
						sx={{
							//height: "auto",
							gap: "5px",
						}}
						px={2}
						py={1}
						mx={2.4}
					>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "0px",
									width: "14px",
									border: "2px solid #006837",
									backgroundColor: "none",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Trail</Box>
						</Box>
					</Box>
				) : name.toLowerCase().includes("playground") ? (
					<Box
						display="flex"
						flexDirection="column"
						sx={{
							//height: "auto",
							gap: "5px",
						}}
						px={2}
						py={1}
						mx={2.4}
					>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "14px",
									width: "14px",
									border: "1px solid #d6548d",
									backgroundColor: "#eaa9c6",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Playground</Box>
						</Box>
					</Box>
				) : name.toLowerCase() == "school" ? (
					<Box
						display="flex"
						flexDirection="column"
						sx={{
							//height: "auto",
							gap: "5px",
						}}
						px={2}
						py={1}
						mx={2.4}
					>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "14px",
									width: "14px",
								}}
							>
								<img
									height="14px"
									src={flag}
								/>
							</Box>
							<Box sx={{ marginLeft: "10px" }}>Schoolyard</Box>
						</Box>
					</Box>
				) : name.toLowerCase().includes("10-minute") ? (
					<Box
						display="flex"
						flexDirection="column"
						sx={{
							//height: "auto",
							gap: "5px",
						}}
						px={2}
						py={1}
						mx={2.4}
					>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "14px",
									width: "14px",
									border: "1px solid #a3cceb",
									backgroundColor: "#e0eff8",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>10 Minute Walk Service Area</Box>
						</Box>
					</Box>
				) : name.toLowerCase().includes("college") ? (
					<Box
						display="flex"
						flexDirection="column"
						sx={{
							//height: "auto",
							gap: "5px",
						}}
						px={2}
						py={1}
						mx={2.4}
					>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "14px",
									width: "14px",
									border: "1px solid #fed326",
									backgroundColor: "#fed326",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>College / University</Box>
						</Box>
					</Box>
				) : name.toLowerCase().includes("zero") ? (
					<Box
						display="flex"
						flexDirection="column"
						sx={{
							//height: "auto",
							gap: "5px",
						}}
						px={2}
						py={1}
						mx={2.4}
					>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "14px",
									width: "14px",
									border: "1px solid #bdbbb7",
									backgroundColor: "#bdbbb7",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Vacant Zero Population Area</Box>
						</Box>
					</Box>
				) : name.toLowerCase().includes("airport") ? (
					<Box
						display="flex"
						flexDirection="column"
						sx={{
							//height: "auto",
							gap: "5px",
						}}
						px={2}
						py={1}
						mx={2.4}
					>
						<Box
							display="flex"
							flexDirection="row"
							justifyContent="start"
							alignItems="center"
							fontSize="12px"
						>
							<Box
								sx={{
									height: "14px",
									width: "14px",
									border: "1px solid #cdccc8",
									backgroundColor: "#cdccc8",
								}}
							/>{" "}
							<Box sx={{ marginLeft: "10px" }}>Airports</Box>
						</Box>
					</Box>
				) : (
					<Box />
				)}
			</Box>
		);
	};

	const CreateLegend = ({ name }: any) => {
		return name.toLowerCase().includes("to get star") ? (
			<Box />
		) : name.toLowerCase().includes("priority areas") ? (
			<Box>
				<Box
					display="flex"
					flexDirection="column"
					sx={{
						gap: "5px",
					}}
					px={2}
					py={1}
					mx={2.4}
				>
					<Box
						display="flex"
						flexDirection="row"
						justifyContent="start"
						alignItems="center"
						fontSize="12px"
					>
						<Box
							sx={{
								height: "15px",
								width: "15px",
								backgroundColor: "#795299",
							}}
						/>{" "}
						<Box sx={{ marginLeft: "10px" }}>Very High</Box>
					</Box>
					<Box
						display="flex"
						flexDirection="row"
						justifyContent="start"
						alignItems="center"
						fontSize="12px"
					>
						<Box
							sx={{
								height: "15px",
								width: "15px",
								backgroundColor: "#a77ec9",
							}}
						/>{" "}
						<Box sx={{ marginLeft: "10px" }}>High</Box>
					</Box>
					<Box
						display="flex"
						flexDirection="row"
						justifyContent="start"
						alignItems="center"
						fontSize="12px"
					>
						<Box
							sx={{
								height: "15px",
								width: "15px",
								backgroundColor: "#d0bbe2",
							}}
						/>{" "}
						<Box sx={{ marginLeft: "10px" }}>Moderate</Box>
					</Box>
				</Box>
			</Box>
		) : name.includes("Park and Trail Sketch") ? (
			<Box>{name}</Box>
		) : name.includes("walk layer") ? (
			<Box>
				<Box
					display="flex"
					flexDirection="column"
					sx={{ height: "auto", gap: "10px" }}
					px={2}
					py={1}
				>
					<Box
						display="flex"
						flexDirection="row"
						justifyContent="start"
						alignItems="center"
						fontSize="12px"
					>
						<Box
							sx={{
								height: "15px",
								width: "15px",
								backgroundColor: "#e2ea9f",
								border: "2px dotted #afbd42",
							}}
						/>{" "}
						<Box sx={{ marginLeft: "10px" }}>
							10 Minute Walk Area from Selected Park
						</Box>
					</Box>
				</Box>
			</Box>
		) : name.includes("10") ? (
			<Box>
				<Box
					display="flex"
					flexDirection="column"
					sx={{ height: "auto", gap: "10px" }}
					px={2}
					py={1}
				>
					<Box
						display="flex"
						flexDirection="row"
						justifyContent="start"
						alignItems="center"
						fontSize="12px"
					>
						<Box
							sx={{
								height: "15px",
								width: "15px",
								backgroundColor: "#dbe8d2",
							}}
						/>{" "}
						<Box sx={{ marginLeft: "10px" }}>
							<Typography variant="tab">10-Minute Walk Service Area</Typography>
						</Box>
					</Box>
				</Box>
			</Box>
		) : name.toLowerCase().includes("public") ? (
			<Box>
				<Box
					display="flex"
					flexDirection="column"
					sx={{ height: "auto", gap: "10px" }}
					px={2}
					py={1}
				>
					<Box
						display="flex"
						flexDirection="row"
						justifyContent="start"
						alignItems="center"
						fontSize="12px"
					>
						<Box
							sx={{
								height: "15px",
								width: "15px",
								backgroundColor: "#77bd75",
							}}
						/>{" "}
						<Box sx={{ marginLeft: "10px" }}>Parks with Public Access</Box>
					</Box>
				</Box>
			</Box>
		) : name.toLowerCase().includes("parkserve") ? (
			<Box>
				<Box
					display="flex"
					flexDirection="column"
					sx={{ height: "auto", gap: "5px" }}
					px={2}
					py={1}
				>
					<Box
						display="flex"
						flexDirection="row"
						justifyContent="start"
						alignItems="center"
						fontSize="12px"
					>
						<Box
							sx={{
								height: "15px",
								width: "15px",
								backgroundColor: "white",
								border: "5px solid #b2b2b2",
							}}
						/>{" "}
						<Box sx={{ marginLeft: "10px" }}>
							{name.toLowerCase().includes("urban")
								? "Urban Areas"
								: "City Areas"}
						</Box>
					</Box>
				</Box>
			</Box>
		) : name.toLowerCase().includes("custom prioritization") ? (
			<Box>
				<Box
					display="flex"
					flexDirection="column"
					sx={{ height: "auto", gap: "5px" }}
					px={2}
					py={1}
					mx={2.4}
				>
					<Box
						display="flex"
						flexDirection="row"
						justifyContent="start"
						alignItems="center"
						fontSize="12px"
					>
						<Box
							sx={{
								height: "15px",
								width: "15px",
								backgroundColor: customPrioritizationLayerColors.veryHigh,
							}}
						/>{" "}
						<Box sx={{ marginLeft: "10px" }}>Very High</Box>
					</Box>
					<Box
						display="flex"
						flexDirection="row"
						justifyContent="start"
						alignItems="center"
						fontSize="12px"
					>
						<Box
							sx={{
								height: "15px",
								width: "15px",
								backgroundColor: customPrioritizationLayerColors.high,
							}}
						/>{" "}
						<Box sx={{ marginLeft: "10px" }}>High</Box>
					</Box>
					<Box
						display="flex"
						flexDirection="row"
						justifyContent="start"
						alignItems="center"
						fontSize="12px"
					>
						<Box
							sx={{
								height: "15px",
								width: "15px",
								backgroundColor: customPrioritizationLayerColors.moderate,
							}}
						/>{" "}
						<Box sx={{ marginLeft: "10px" }}>Moderate</Box>
					</Box>
				</Box>
			</Box>
		) : (
			<Box>No Legend Info</Box>
		);
	};

	const LayerWrapper = ({ layer }: any) => {
		if (
			!layer.title ||
			layer.title === "GraphicMover highlight layer" ||
			layer.title === "SVM Internal"
		) {
			return null;
		}
		return (
			<Accordion
				disableGutters
				expanded={true}
				elevation={0}
				sx={{ borderBottom: 0 }}
			>
				<Tooltip
					disableTouchListener
					title={exploreTooltips[layer.title.toUpperCase()] || layer.title}
					placement="right"
				>
					<AccordionSummary
						sx={{
							flexDirection: "row-reverse",
							minHeight: "20px",
						}}
						onClick={() => changeLayerVisibility(layer)}
						expandIcon={
							layer.visible ? (
								<span className="esri-icon-visible left-panel__layer-icon left-panel__layer-icon--visible font-size-3"></span>
							) : (
								<span className="esri-icon-non-visible left-panel__layer-icon left-panel__layer-icon--hidden font-size-3"></span>
							)
						}
					>
						<Box
							sx={{
								height: "15px",
								width: "5px",
							}}
						/>

						{layer.title.includes("10") ||
						layer.title.toLowerCase().includes("public") ||
						layer.title.toLowerCase().includes("urban cities") ? (
							<Box
								sx={{
									height: "15px",
									width: "15px",
									backgroundColor: layer.title.includes(
										"10-minute walk service area"
									)
										? "#dbe8d2"
										: layer.title.toLowerCase().includes("urban cities")
										? "#e9a273"
										: "#77bd75",
									marginRight: "10px",
								}}
							/>
						) : (
							<Box />
						)}

						{layer.title.includes("Priority") ? (
							<Typography
								sx={{ maxWidth: "75%" }}
								variant="tab"
							>
								{layer.title.split("(")[0]}
							</Typography>
						) : (
							<Typography
								sx={{ maxWidth: "75%", marginTop: "1px" }}
								variant="tab"
							>
								{layer.title}
							</Typography>
						)}
					</AccordionSummary>
				</Tooltip>
				<AccordionDetails
					sx={{
						padding: 0,
						margin: 0,
					}}
				>
					{layer.title.toLowerCase().includes("priority") ||
					layer.title.toLowerCase().includes("custom") ? (
						<CreateLegend name={layer.title} />
					) : (
						<Box />
					)}
				</AccordionDetails>
			</Accordion>
		);
	};

	const OverlayWrapper = ({ layer }: any) => {
		return (
			<Accordion
				disableGutters
				expanded={layer.visible}
				elevation={0}
				sx={{
					borderBottom: 0,
					border: 0,
					outline: 0,
					"&:before": {
						display: "none",
					},
				}}
			>
				<Tooltip
					disableTouchListener
					title={exploreTooltips[layer.title.toUpperCase()] || layer.title}
					placement="right"
				>
					<AccordionSummary
						sx={{
							flexDirection: "row-reverse",
							minHeight: "20px",
							border: 0,
							borderBottom: 0,
							outline: 0,
						}}
						onClick={() => changeLayerVisibility(layer)}
						expandIcon={
							layer.visible ? (
								<span className="esri-icon-visible left-panel__layer-icon left-panel__layer-icon--visible font-size-3"></span>
							) : (
								<span className="esri-icon-non-visible left-panel__layer-icon left-panel__layer-icon--hidden font-size-3"></span>
							)
						}
					>
						<Box
							sx={{
								height: "15px",
								width: "5px",
							}}
						/>

						<Typography
							sx={{ maxWidth: "75%", marginTop: "1px" }}
							variant="tab"
						>
							{layer.title}
						</Typography>
					</AccordionSummary>
				</Tooltip>

				<AccordionDetails
					sx={{
						padding: 0,
						margin: 0,
					}}
				>
					<CreateOverlayLegend name={layer.title} />
				</AccordionDetails>
			</Accordion>
		);
	};

	return (
		<TPLSlidePanel>
			{layerList?.map((layer: __esri.Layer) => (
				<LayerWrapper
					key={layer.title}
					layer={layer}
				/>
			))}
			<Divider sx={{ marginTop: "10px", marginBottom: "10px" }} />
			{overlays?.map((overlay: any) =>
				overlay.title.toLowerCase() != "parkserve cities and towns" ? (
					<Box key={overlay.title}>
						<Tooltip
							disableTouchListener
							title={
								exploreTooltips[overlay.title.toUpperCase()] || overlay.title
							}
							placement="right"
						>
							<div>{overlay.title}</div>
						</Tooltip>
						{overlay.layers.map((layer: any) => (
							<OverlayWrapper
								key={layer.title}
								layer={layer}
							/>
						))}
					</Box>
				) : (
					<Box />
				)
			)}
		</TPLSlidePanel>
	);
}
